import React from 'react';
import { Link } from 'gatsby';
import BlogPostCard from './BlogPostCard';
import Button from './common/Button';

interface BlogPost {
  title: string;
  featuredImage: {
    fluid: {
      src: string;
    };
  };
  slug: string;
  publishedDate: string;
  author: {
    firstName: string;
    lastName: string;
    image: {
      fluid: {
        src: string;
      };
    };
  };
}

interface BlogPostSectionProps {
  blogPosts: BlogPost[];
  blogFallbackImage: any;
}

const BlogPostsSection: React.FC<BlogPostSectionProps> = props => {
  return (
    <>
      <div className="container mx-auto px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {props.blogPosts.map((post: BlogPost, i: number) => {
              return (
                <BlogPostCard
                  key={i}
                  title={post.title}
                  image={
                    post.featuredImage?.fluid?.src ??
                    props.blogFallbackImage.childImageSharp.sizes.src
                  }
                  author={post.author}
                  publishedDate={post.publishedDate}
                  link={`/blog/${post.slug}`}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="text-center mt-12">
        <Link to="/blog">
          <Button
            className="bg-primary text-white hover:bg-primary/90"
            text="View More Blog Posts"
            size="md"
          />
        </Link>
      </div>
    </>
  );
};

export default BlogPostsSection;
